import * as Sentry from "@sentry/react";

export const log = (message, data) => {
  Sentry.addBreadcrumb({
    message: message
  });

  console.log(message, data);
}
